import { render } from "./GeneralLedgerDetail.vue?vue&type=template&id=5e0e1242"
import script from "./GeneralLedgerDetail.vue?vue&type=script&lang=js"
export * from "./GeneralLedgerDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Accounting/GeneralLedgerDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e0e1242"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e0e1242', __exports__)) {
    api.reload('5e0e1242', __exports__)
  }
  
  module.hot.accept("./GeneralLedgerDetail.vue?vue&type=template&id=5e0e1242", () => {
    api.rerender('5e0e1242', render)
  })

}


export default __exports__